var module = angular.module('main.customerorder');

module.component('caCustomerOrderRows',{
    templateUrl: 'main/customerorder/customerordersearch/customerordercontent/customerorderrows.cmp.tpl.html',
    bindings: {
        customerOrder: '<',
        navigated: '&'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($state, $translate, CustomerOrderApiService) {
    var vm = this;

    //Properties
    vm.hasResellerPrice = false;
    vm.currentCustomerOrderId = 0;

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.getOrderRowTotalSum = getOrderRowTotalSum;
    vm.getOrderRowQuantitySum = getOrderRowQuantitySum;
    vm.showResellerPrice = vm.showResellerPrice;

    function onInit() {

    }
    function onChanges() {
    }

    function setUpGridData() {
    }

    function loadGridData() {
    }

    function getOrderRowTotalSum(orderRows) {
        var sum = 0;
        _.forEach(orderRows, function (row) {
            sum += (row.salesPrice * row.quantity);
        });
        return sum;
    }

    function getOrderRowQuantitySum(orderRows) {
        var sum = 0;
        _.forEach(orderRows, function (row) {
            sum += row.quantity;
        });
        return sum;
    }

    function showResellerPrice() {
        if (!vm.customerOrder) { return false; }
        if (vm.customerOrder.id === vm.currentCustomerOrderId && vm.hasResellerPrice) {
            return true;
        }

        vm.currentCustomerOrderId = vm.customerOrder.id;
        var hasResellerPrice = _.find(vm.customerOrder.orderRows, function(row) {
            return row.resellerSalesPrice !== 0 || row.resellerVatAmount !== 0;
        });
        vm.hasResellerPrice = hasResellerPrice !== undefined;

        return vm.hasResellerPrice;
    }
}
